module.exports = __webpack_public_path__ + "media/images/views/home/home-features-photo-3-8505eec41f6d5ebff323b38488f87797.png";